'use strict';

import {cardsData, isMobile, settingsData} from "../../settings";
import {createPopUp} from "./statistic";
import Notiflix from 'notiflix';
import { getCookie, setCookie } from '../cookies/setAndGetCookies';
import { getCurrentLangDirection, isDesktopMode } from '../language/langSwitcher';
import { CardTypes } from '../../common';

export const conferenceStatistic = (object) => {
    if (isMobile || cardsData.cardMode.isAmenities || cardsData.cardMode.isUnavailable) return;

    const optionCard = document.querySelector(`.${CardTypes.Options}-card`);
    if (!optionCard){
        return;
    }

    let statisticCnt;

    if (typeof window.localStorage !== 'undefined' ) {
        statisticCnt = JSON.parse(localStorage.getItem('statisticCnt'))?.[object.engineId];
    } else {
        statisticCnt = getCookie('statisticCnt')?.[object.engineId];
    }

    let statisticData;

    if (!statisticCnt) {
        statisticData = setStatisticToStorage();
    } else {
        statisticData = getStatisticFromStorage();
    }

    const {statisticInterestedBlock, statisticFavoritesBlock, statisticBlock} = createPopUp();

    statisticInterestedBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${statisticData.interestCntValue}</span>`);
    statisticFavoritesBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${statisticData.favoritesCntValue}</span>`);
    const copyInterested = statisticBlock.cloneNode(true);
    const copyFavorite = statisticBlock.cloneNode(true);
    const dir = getCurrentLangDirection();

    copyInterested.appendChild(statisticInterestedBlock);
    copyFavorite.appendChild(statisticFavoritesBlock);

    Notiflix.Notify.merge({
        position: isDesktopMode() ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
        rtl: (dir !== 'ltr')
    })

    Notiflix.Notify.info(`${copyInterested.innerHTML}`);
    setTimeout(()=> Notiflix.Notify.info(`${copyFavorite.innerHTML}`),1000);
}

const setStatisticToStorage = (timeFlag) => {
    const now = new Date();
    const apt = settingsData.lastClickedFlat.userData.crm_data.engineId;

    const newObject = {
        'interestCntValue': Math.floor(Math.random(0.1) * 50),
        'favoritesCntValue': Math.floor(Math.random(0.1) * 30),
        'expiry': now.getTime(),
    }

    let object;

    let storageData;

    if (typeof window.localStorage !== 'undefined' ) {
        storageData = JSON.parse(localStorage.getItem('statisticCnt'));
    } else {
        storageData = JSON.parse(getCookie('statisticCnt'));
    }

    if (!storageData) {
        if (typeof window.localStorage !== 'undefined' ) {
            localStorage.setItem('statisticCnt', JSON.stringify({
                [apt]: newObject,
            }))
        } else {
            setCookie('statisticCnt', JSON.stringify({
                [apt]: newObject,
            }))
        }
        object = newObject;
        return object;
    } else if (!storageData[apt] || timeFlag) {
        if (typeof window.localStorage !== 'undefined' ) {
            localStorage.setItem('statisticCnt', JSON.stringify({
                ...storageData, [apt]: newObject,
            }))
        } else {
            setCookie('statisticCnt', JSON.stringify({
                ...storageData, [apt]: newObject,
            }))
        }
        object = newObject;
        return object;
    } else {
        object = storageData[apt];
        return object;
    }

}

const getStatisticFromStorage = () => {
    let statisticCnt;
    if (typeof window.localStorage !== 'undefined' ) {
        statisticCnt = JSON.parse(localStorage.getItem('statisticCnt'));
    } else {
        statisticCnt = getCookie('statisticCnt');
    }

    const apt = settingsData.lastClickedFlat.userData.crm_data.engineId;

    if (!statisticCnt) {
        return null
    }

    const now = new Date();
    const oneDay = 24 * 60 * 60 * 1000;

    if (now.getTime() - statisticCnt[apt].expiry > oneDay) {
        return setStatisticToStorage('timeOver');
    } else {
        return statisticCnt[apt];
    }
}

